import clsx from 'clsx';

import { Avatar } from '../Avatar';
import { Icon } from '../Icon';
import { Tag } from '../Tag';
import { Typography } from '../typography';

import type { AvatarProps } from '../Avatar';
import type { TagProps } from '../Tag';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

import s from './UsersPreview.module.css';

export type UsersPreviewProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  /** Array of users to display */
  users: Omit<AvatarProps, 'className' | 'size' | 'withBorder'>[];
  /** Tag color for count badge */
  tagColor?: TagProps['color'];
};

export const UsersPreview = ({ className, tagColor = 'default', users, ...props }: UsersPreviewProps) => {
  const displayUsers = users.slice(0, 3);
  const remainingCount = users.length - 3;

  return (
    <div className={clsx(s.container, className)} {...props}>
      {displayUsers.map((avatarProps, index) => {
        const isMiddleOfThree = users.length === 3 && index === 1;

        return (
          <Avatar
            key={index}
            {...avatarProps}
            className={clsx(s.item, isMiddleOfThree && s.item_middle)}
            size="small"
            withBorder
          />
        );
      })}

      {remainingCount > 0 && (
        <Tag
          className={clsx(s.item, s.item_tag)}
          color={tagColor}
          suffix={<Icon height={18} name="arrow-link" width={18} />}
        >
          <Typography component="span">{remainingCount}</Typography>
        </Tag>
      )}
    </div>
  );
};
